// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__oxx_X","col":"styles_col__1HYsZ"};